import styled from '@emotion/styled';
import { Text, Img } from '@zapier/design-system';
import { mediaQueries } from '../../../constants';

type ItemProps = {
  logoUrl: string;
  companyName: string;
  height?: number;
  width?: number;
};

type Props = {
  title: string;
  items: Array<ItemProps>;
};

/**
 * @deprecated
 * This component has been deprecated. `LogoBarV2` should be used instead.
 */
export function LogoBar({ title, items }: Props) {
  return (
    <Container>
      <Text color="gray" margin="0 0 35px 0" tag="p" type="paragraph3">
        {title}
      </Text>
      <LogosContainer>
        {items.map(({ logoUrl, companyName, ...restProps }, i) => (
          <LogoContainer key={i + logoUrl}>
            <Img
              alt={companyName}
              borderRadius={0}
              src={logoUrl}
              {...restProps}
            />
          </LogoContainer>
        ))}
      </LogosContainer>
    </Container>
  );
}

const Container = styled.div`
  margin: 0 auto;
  padding: 55px 25px 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1280px;
`;

const LogosContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`;

const LogoContainer = styled.div`
  margin-bottom: 30px;

  ${mediaQueries.tablet} {
    margin-bottom: 35px;

    &:not(:last-child) {
      margin-right: 50px;
    }
  }

  ${mediaQueries.desktop} {
    &:not(:last-child) {
      margin-right: 80px;
    }
  }
`;
